// Generated from the Upzi DLS Figma icon library by sync-dls-icons.mjs.
import { createDlsIcon } from './dls-icon';

const ShareIcon = createDlsIcon('ShareIcon', {
  filled: (
    <>
      <path
        d="M36.5 5C35.5015 5.00126 34.5167 5.23253 33.6221 5.67587C32.7274 6.11922 31.9469 6.76272 31.3411 7.55645C30.7353 8.35019 30.3206 9.27281 30.129 10.2527C29.9374 11.2327 29.9741 12.2436 30.2363 13.207L30.1211 13.2637L16.7383 19.9531L16.623 20.0098C16.0162 19.2294 15.2393 18.5977 14.3516 18.1628C13.4638 17.7279 12.4886 17.5012 11.5 17.5C9.77609 17.5 8.12279 18.1848 6.90381 19.4038C5.68482 20.6228 5 22.2761 5 24C5 25.7239 5.68482 27.3772 6.90381 28.5962C8.12279 29.8152 9.77609 30.5 11.5 30.5C12.4892 30.4994 13.4652 30.273 14.3537 29.838C15.2422 29.4031 16.0197 28.7711 16.627 27.9902L16.7383 28.0469L30.1211 34.7363L30.2305 34.791C29.9678 35.7551 29.9308 36.7667 30.1226 37.7473C30.3143 38.728 30.7296 39.6512 31.3361 40.4453C31.9425 41.2394 32.7239 41.883 33.6195 42.326C34.5151 42.7691 35.5008 42.9997 36.5 43C38.2239 43 39.8772 42.3152 41.0962 41.0962C42.3152 39.8772 43 38.2239 43 36.5C43 34.7761 42.3152 33.1228 41.0962 31.9038C39.8772 30.6848 38.2239 30 36.5 30C35.5889 30.0013 34.6883 30.1941 33.8565 30.5659C33.0248 30.9377 32.2804 31.4802 31.6719 32.1582L31.4609 32.0527L18.0801 25.3633L17.8711 25.2598C18.0345 24.4285 18.0339 23.5732 17.8691 22.7422L18.0801 22.6367L31.4609 15.9473L31.666 15.8438C32.2754 16.5221 33.0208 17.0647 33.8536 17.4362C34.6864 17.8077 35.5881 17.9998 36.5 18C38.2239 18 39.8772 17.3152 41.0962 16.0962C42.3152 14.8772 43 13.2239 43 11.5C43 9.77609 42.3152 8.12279 41.0962 6.90381C39.8772 5.68482 38.2239 5 36.5 5Z"
        fill="currentColor"
      />
    </>
  ),
  outline: (
    <>
      <path
        d="M15.5 24C15.5 22.067 13.933 20.5 12 20.5C10.067 20.5 8.5 22.067 8.5 24C8.5 25.933 10.067 27.5 12 27.5C13.933 27.5 15.5 25.933 15.5 24ZM19.5 24C19.5 28.1421 16.1421 31.5 12 31.5C7.85786 31.5 4.5 28.1421 4.5 24C4.5 19.8579 7.85786 16.5 12 16.5C16.1421 16.5 19.5 19.8579 19.5 24Z"
        fill="currentColor"
      />
      <path
        d="M39.5 12C39.5 10.067 37.933 8.5 36 8.5C34.067 8.5 32.5 10.067 32.5 12C32.5 13.933 34.067 15.5 36 15.5C37.933 15.5 39.5 13.933 39.5 12ZM43.5 12C43.5 16.1421 40.1421 19.5 36 19.5C31.8579 19.5 28.5 16.1421 28.5 12C28.5 7.85786 31.8579 4.5 36 4.5C40.1421 4.5 43.5 7.85786 43.5 12Z"
        fill="currentColor"
      />
      <path
        d="M39.5 36C39.5 34.067 37.933 32.5 36 32.5C34.067 32.5 32.5 34.067 32.5 36C32.5 37.933 34.067 39.5 36 39.5C37.933 39.5 39.5 37.933 39.5 36ZM43.5 36C43.5 40.1421 40.1421 43.5 36 43.5C31.8579 43.5 28.5 40.1421 28.5 36C28.5 31.8579 31.8579 28.5 36 28.5C40.1421 28.5 43.5 31.8579 43.5 36Z"
        fill="currentColor"
      />
      <path
        d="M31.9747 16.2491L17.8145 23.3291L16.0255 19.751L30.1856 12.6709L31.9747 16.2491Z"
        fill="currentColor"
      />
      <path
        d="M31.9747 31.751L30.1856 35.3291L16.0255 28.2491L17.8145 24.6709L31.9747 31.751Z"
        fill="currentColor"
      />
    </>
  ),
});

export { ShareIcon };
export default ShareIcon;
